import { Button } from "@devhop/ui";
import { CalendarDaysIcon, LayoutListIcon } from "lucide-react";

type EventViewToggleProps = {
  view: "list" | "calendar";
  onChange: (view: "list" | "calendar") => void;
};

export function EventViewToggle({ view, onChange }: EventViewToggleProps) {
  return (
    <div className="inline-flex rounded-lg border bg-muted/30 p-1">
      <Button
        type="button"
        size="sm"
        variant={view === "list" ? "default" : "ghost"}
        className="h-8 gap-1.5 px-3"
        onClick={() => onChange("list")}
      >
        <LayoutListIcon className="size-4" />
        ຕາຕະລາງ
      </Button>
      <Button
        type="button"
        size="sm"
        variant={view === "calendar" ? "default" : "ghost"}
        className="h-8 gap-1.5 px-3"
        onClick={() => onChange("calendar")}
      >
        <CalendarDaysIcon className="size-4" />
        ປະຕິທິນ
      </Button>
    </div>
  );
}
